import React, { useEffect, useState } from "react";
import ChatBox from "../../Components/common/MessageComponents/ChatBox";
import axios from "axios";
import { apiMainUser, capitalizeText } from "../../utils/constant";
import LeftMessgeCardWrappers from "../../Components/common/MessageComponents/LeftMessgeCardWrappers";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
// import {
//   ADD_MESSAGE,
//   INCREASE_UNREAD_COUNT_BY_ROOMID,
//   INITIALIZE_CHATROOM_UNREAD_COUNT,
//   SET_CHANNEL,
//   SET_CHATROOMS,
//   SET_PUSHER,
//   SET_SELECTED_ROOM_ID,
//   SET_SELECTED_ROOM_ID_MESSAGES,
//   chatEntryExitThunk,
// } from "../../utils/redux/User/MessageUserSideSlice";

import {
  ADD_MESSAGE,
  INCREASE_UNREAD_COUNT_BY_ROOMID,
  INITIALIZE_CHATROOM_UNREAD_COUNT,
  RESET_STATE,
  SET_CHANNEL,
  SET_CHATROOMS,
  SET_CHATROOMS_LOADIND,
  SET_PUSHER,
  SET_SELECTED_ROOM_ID,
  SET_SELECTED_ROOM_ID_MESSAGES,
  chatEntryExitThunk,
  fetchChatByRoomIdThunk,
  getChatRooms,
} from "../../utils/redux/messageSlice";

import Pusher from "pusher-js";
import RightMessagePostCard from "../../Components/common/MessageComponents/RightMessagePostCard";
import CardWrapper from "../../Components/common/cardWrapper";
import GuestBasic from "../../Components/common/guestBasic";
import ProfileImage from "../../Components/common/profileImg";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import NoChatRoomsFound from "../../Components/common/MessageComponents/NoChatRoomsFound";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const NewMessageUserSidePage = () => {
  const [chatRoomsHost, setChatRoomsHost] = useState([]);
  const [assetsurl, setAssetsUrl] = useState();
  const [step, setStep] = useState(-1);

  const storeSel = useSelector((state) => state);
  const userData = storeSel.hostDetailSlice.user_Name;

  const [channel, setChannel] = useState();

  const [formattedCheckInDate, setFormattedCheckInDate] = useState();
  const [formattedCheckOutDate, setformattedCheckOutDate] = useState();

  const [pusherInstance, setPusherInstance] = useState();
  const [channelInstance, setChannelInstance] = useState();

  // const {
  //   rightSideContent,
  //   chatRoomUnreadCount,
  //   selectedRoomId,
  //   chatRooms,
  // } = useSelector((state) => state.MessageUserSide);

  const {
    rightSideContent,
    chatRoomUnreadCount,
    selectedRoomId,
    chatRooms,
    chatRoomsLoading,
  } = useSelector((state) => state.Message);

  const isSmallScreen = window.innerWidth <= 500;

  // const { pusherInstance, channelInstance } = useSelector(
  //   (state) => state.MessageUserSide
  // );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const chatEntryExit = async ({ oldRoomID, newRoomID }) => {
    try {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      if (oldRoomID) {
        await axios.post(
          apiMainUser + "chat_entry_exit",
          {
            chat_room_id: oldRoomID,
            event: "exit",
          },
          { headers }
        );
      }

      if (newRoomID) {
        axios.post(
          apiMainUser + "chat_entry_exit",
          {
            chat_room_id: newRoomID,
            event: "entry",
          },
          { headers }
        );
      }

      console.log("Entered chat room:", newRoomID);
      console.log("Existed chat room:", oldRoomID);
    } catch (error) {
      console.error("Error entering chat room:", error);
    }
  };

  const initializePusher = () => {
    if (!pusherInstance) {
      console.log("initialising pusher <===");

      const pusher = new Pusher("582888e794e6b9a114e3", {
        cluster: "ap2",
      });

      // dispatch(SET_PUSHER(pusher));
      setPusherInstance(pusher);

      const channel = pusher.subscribe("Chats");

      // dispatch(SET_CHANNEL(channel));
      setChannelInstance(channel);
    }
  };

  useEffect(() => {
    if (channelInstance && chatRoomsHost.length > 0) {
      console.log("channel bind ran");

      channelInstance.unbind_all(); // Unbind all events to start fresh
      bindPusherForEachChatRoom(channelInstance); // Rebind relevant events
    }
  }, [channelInstance, chatRoomsHost]);

  const bindPusherForEachChatRoom = (channel) => {
    console.log("inside bind function");

    if (chatRoomsHost.length > 0) {
      console.log(chatRoomsHost, "inside bind function chatroom length check");
      chatRoomsHost.map((chatRoom, index) => {
        console.log("inside map ", index, chatRoom.room_id, channel);

        try {
          channel.bind(chatRoom.room_id, (data) => {
            console.log("channel_bind for --> ", chatRoom.room_id);
            const newMessage = {
              message_type: "",
              message: data.message_array[0].message,
              createdon: data.message_array[0].createdon,
              lead_event_id: data.message_array[0].lead_event_id,
              updatedon: data.message_array[0].updatedon,
              message_from: data.message_array[0].message_from,
              you: 0,
            };

            dispatch(
              INCREASE_UNREAD_COUNT_BY_ROOMID({
                type: 0,
                roomID: chatRoom.room_id,
              })
            );

            dispatch(
              ADD_MESSAGE({ roomId: chatRoom.room_id, message: newMessage })
            );
          });
        } catch (err) {
          alert("channel bind error");
          console.error("Error in channel binding");
        }
      });
    }
  };

  useEffect(() => {
    if (chatRoomsHost.length != 0) {
      initializePusher();

      const unreadMessagesStarter = {};

      chatRoomsHost.map(
        (room) => (unreadMessagesStarter[room.room_id] = room.unread_message)
      );

      dispatch(
        INITIALIZE_CHATROOM_UNREAD_COUNT({
          type: 0,
          chatRoomUnreadCount: unreadMessagesStarter,
        })
      );
    }
  }, [chatRoomsHost]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(SET_CHATROOMS_LOADIND(0));
        const response = await axios.get(apiMainUser + "get_chat_rooms", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status === 200) {
          const roomData = response.data.data;
          setAssetsUrl(response.data.assets_url);
          setChatRoomsHost(roomData.reverse());
          console.log("roomData", roomData);
          dispatch(SET_CHATROOMS({ roomData: roomData, type: 0 }));
          let initialRoomId = roomData[0]?.room_id;

          if (searchParams.get("room_id")) {
            initialRoomId = searchParams.get("room_id");
          }

          dispatch(SET_SELECTED_ROOM_ID({ type: 0, room_id: initialRoomId }));
          // dispatch(fetchChatByRoomIdThunk({ roomId: initialRoomId }));

          // await dispatch(
          //   chatEntryExitThunk({ oldRoomID: null, newRoomID: initialRoomId })
          // );
          chatEntryExit({ oldRoomID: null, newRoomID: initialRoomId });
          // dispatch(
          //   chatEntryExitThunk({ oldRoomID: null, newRoomID: initialRoomId })
          // )
          //   .unwrap()
          //   .then((result) => {
          //     console.log("Thunk completed with result:", result);
          //     // Handle any additional logic after thunk completes
          //   })
          //   .catch((error) => {
          //     console.error("Thunk failed with error:", error);
          //     // Handle error as needed
          //   });

          const queryParams = new URLSearchParams(window.location.search);
          queryParams.set("room_id", initialRoomId);
          const newUrl = queryParams.toString()
            ? `${window.location.pathname}?${queryParams.toString()}`
            : window.location.pathname;
          window.history.replaceState({}, "", newUrl);
        } else {
          console.error("Failed to fetch:", response.status);
        }
      } catch (error) {
        console.error("Error fetching:", error);
      }
    };
    fetchData();

    // dispatch(getChatRooms(type));
  }, [searchParams]);

  useEffect(() => {
    const cleanup = () => {
      if (selectedRoomId) {
        chatEntryExit({ oldRoomID: selectedRoomId, newRoomID: null });
      }

      if (channelInstance && chatRoomsHost.length > 0) {
        chatRoomsHost.forEach((chatRoom) => {
          channelInstance.unbind(chatRoom.room_id);
        });

        console.log("channel cleanup");
        channelInstance.unsubscribe();
        channelInstance.disconnect();

        // dispatch(SET_CHANNEL(null));
        setChannelInstance(null);
      }

      if (pusherInstance) {
        if (channelInstance) pusherInstance.unsubscribe(channelInstance);

        pusherInstance.disconnect();

        console.log("pusher cleanup");
        // dispatch(SET_PUSHER(null));
        setPusherInstance(null);
      }

      // dispatch(RESET_STATE());
    };

    return cleanup;
  }, [channelInstance, pusherInstance]);

  const handleApiCall = (roomId) => {
    console.log("justCalled");
    // const isSmallScreen = window.innerWidth <= 500;
    if (selectedRoomId)
      chatEntryExit({
        oldRoomID: selectedRoomId,
        newRoomID: roomId,
      });
    // dispatch(
    //   chatEntryExitThunk({
    //     oldRoomID: selectedRoomId,
    //     newRoomID: roomId,
    //   })
    // );

    if (roomId != selectedRoomId) {
      dispatch(SET_SELECTED_ROOM_ID_MESSAGES([]));
      dispatch(SET_SELECTED_ROOM_ID({ type: 0, room_id: roomId }));
    }

    // dispatch(fetchChatByRoomIdThunk({ roomId: roomId }));

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("room_id", roomId);

    // Replace the current state without causing a full page reload
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.replaceState({}, "", newUrl);

    console.log(isSmallScreen, "checkScreen");

    if (isSmallScreen) {
      console.log("ander");
      setStep(0);
      // setIsMessageMoved(prevState => !prevState);
    }
  };

  useEffect(() => {
    if (rightSideContent) {
      setFormattedCheckInDate(
        moment(rightSideContent?.lead_event_details[0].checkin_date).format(
          "ddd DD MMM YYYY"
        )
      );

      setformattedCheckOutDate(
        moment(rightSideContent?.lead_event_details[0].checkout_date).format(
          "ddd DD MMM YYYY"
        )
      );
    }
  }, [rightSideContent]);

  const navigateToProfile = () => {
    navigate(`/users/${rightSideContent?.chat_users?.[1]?.username}`);
  };

  const moveToThirdStep = () => {
    if (isSmallScreen) {
      console.log("ander");
      setStep(1);
      // setIsMessageMoved(prevState => !prevState);
    }
  };

  return (
    <div className="message-page message-user-page">
      {chatRooms.length == 0 && <NoChatRoomsFound />}
      <div
        className={`message-left-div child-div ${
          step === 0 || step === 1 ? "translated" : step === -1 ? "initial" : ""
        }`}
      >
        <p
          style={{
            fontSize: "20px",
            fontWeight: "700",
            margin: "1rem 0rem 3rem",
          }}
        >
          Messages
        </p>
        {/* {chatRooms && JSON.stringify(chatRooms)} */}

        {chatRooms &&
          chatRooms.length != 0 &&
          chatRooms.map((room) => {
            const matchingUser = room?.chat_users.find(
              (user) => user.username == userData
            );

            if (matchingUser) {
              const firstUser = room?.chat_users[1];
              const guestImg = firstUser.image
                ? assetsurl + firstUser.image
                : "/assets/img/userIconImg.jpg";
              const guestName = `${capitalizeText(
                firstUser.fname
              )} ${capitalizeText(firstUser.lname)}`;
              // const checkinDate = moment(room?.lead_event_details[0]?.checkin_date).format('D');
              // const checkoutDate = moment(room?.lead_event_details[0]?.checkout_date).format('D MMMM');

              // const messageDates = `${checkinDate}-${checkoutDate}`;

              return (
                <LeftMessgeCardWrappers
                  key={room.room_id}
                  guestImg={guestImg}
                  location={room?.property_details[0]?.property_city || ""}
                  guestName={guestName}
                  messageText="." // Add your dynamic messageText logic here
                  // messageEnquirytext='Cancelled'

                  selectedCheckIn={room?.lead_event_details[0]?.checkin_date}
                  selectedCheckOut={room?.lead_event_details[0]?.checkout_date}
                  propertyName={room?.property_details[0]?.property_name || ""}
                  // additionalClass='cancelled-text'
                  onClick={() => {
                    handleApiCall(room.room_id);

                    // dispatch(fetchChatByRoomIdThunk({ roomId: room.room_id }));
                  }}
                  // unReadMessage={room.unread_message}
                  unReadMessage={chatRoomUnreadCount[room.room_id]}
                />
              );
            }

            return ""; // If no matching user is found, skip rendering
          })}
      </div>

      <div
        className={`message-middle-div child-div ${
          step === 1
            ? "translated200"
            : step === 0
            ? "translated-self"
            : step === 2
            ? "translated200"
            : ""
        }`}
      >
        <ChatBox
          assetsurl={assetsurl}
          moveToThirdStep={moveToThirdStep}
          type={0}
          setStep={setStep}
        />
      </div>

      {rightSideContent && (
        <div
          className={`message-right-div child-div ${
            step === 2
              ? "translated"
              : step === 1
              ? "translated200"
              : step === -1
              ? "initial"
              : ""
          }`}
        >
          {isSmallScreen && (
            <button
              onClick={() => setStep(0)}
              style={{
                background: "transparent",
                border: "none",
                alignSelf: "flex-start",
                marginLeft: "1rem",
              }}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
          )}

          <RightMessagePostCard
            propertyName={rightSideContent?.property_details[0].property_name}
            Night={rightSideContent?.lead_event_details[0]?.nights}
            propertImg={
              rightSideContent?.property_details[0].base_url_image +
              rightSideContent?.property_details[0].property_images[0]
            }
            adultsCount={rightSideContent?.lead_event_details[0].adults}
            infantCount={rightSideContent?.lead_event_details[0].infants}
            childrenCount={rightSideContent?.lead_event_details[0].children}
            checkIn={formattedCheckInDate}
            checkOut={formattedCheckOutDate}
            confirmationCode={
              rightSideContent?.lead_event_details[0]?.booking_id
            }
          />

          <CardWrapper
            onClick={navigateToProfile}
            wrapperHeading="About Host"
            wrapperClass="about-guest-card pointer"
          >
            <GuestBasic
              guestName={capitalizeText(
                rightSideContent?.chat_users?.[1]?.fname
              )}
              verfiedText="Verified"
              icon="./assets/img/guestverified.svg"
              noReviews={
                rightSideContent?.chat_users?.[1]?.reviewRating?.user
                  ?.review_count
              }
              starIcon="./assets/img/colorStarIcon.svg"
              starPoint={
                rightSideContent?.chat_users?.[1]?.reviewRating?.user
                  ?.total_rating?.Overall_Average
              }
              guestDuration="Jumbo guest since April 2023"
            />

            <ProfileImage
              src={
                rightSideContent?.chat_users?.[1]?.image
                  ? assetsurl + rightSideContent?.chat_users?.[1]?.image
                  : undefined
              }
              width="100%"
            />
          </CardWrapper>
          {/* <Button
             onClick={()=>setReviewModal(true)}
             btnText='Add Review' btnclasses= 'reveiw-btn'/> */}
          {/*  */}
        </div>
      )}
    </div>
  );
};

export default NewMessageUserSidePage;
